import { render } from "./BulkProductGrid.vue?vue&type=template&id=5f122d10&scoped=true"
import script from "./BulkProductGrid.vue?vue&type=script&lang=js"
export * from "./BulkProductGrid.vue?vue&type=script&lang=js"

import "./BulkProductGrid.vue?vue&type=style&index=0&id=5f122d10&scoped=true&lang=css"

import exportComponent from "../../../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5f122d10"]])

export default __exports__